import _ from 'lodash';
import moment from 'moment';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {withStyles} from "@material-ui/core/styles";
import FMPSelect from "../pureForm/FMPSelect";

const styles = () => {
	return {
		fetching : {
			fontStyle : 'italic',
			padding : '10px 0px',
			color : '#777',
		},
		date : {
			paddingRight : 10,
			marginRight : 10,
			borderRight : '1px solid #ccc',
			display : 'flex',
			alignItems : 'center',
			backgroundColor : '#f7f7f7',
		},
		freightType : {
			paddingRight : 10,
			marginRight : 10,
			borderRight : '1px solid #ccc',
			display : 'flex',
			alignItems : 'center'
		},
		dataLine : {
			fontSize : 13,
			color : '#444'
		}
	};
};

class FMPBulkQuotedPriceSelect extends PureComponent {
	render () {
		const {
			label, value, path, onChange,
			error, helpText, md, classes, bulkQuotedPrices,
		} = this.props;

		if (!bulkQuotedPrices) {
			return (<div className={classes.fetching}>Fetching quoted prices...</div>);
		}

		if (_.isEmpty(bulkQuotedPrices)) {
			return (<div className={classes.fetching}>Missing bulk quoted prices for this date / customer</div>);
		}

		//let value, onChange, error;
		//const onChange = event => controller.onChange(event, path);

		const options = _.sortBy(bulkQuotedPrices, 'date').map(bulkQuotedPrice => {
			const {
				bulkQuotedPriceId, date, quotedPrice,
			} = bulkQuotedPrice;

			const displayDate = moment(date).format('M/D');
			return {
				value: bulkQuotedPriceId,
				display: (
					<div style={{display: 'flex'}}>
						<div className={classes.date}>{displayDate}</div>
						<div><strong>Quoted Price : {quotedPrice}</strong></div>
					</div>
				)
			};
		});

		return (
			<FMPSelect
				label={label}
				path={path}
				value={value}
				error={error}
				options={options}
				onChange={onChange}
				md={md}
				helpText={helpText}
			/>
		);
	}
}

FMPBulkQuotedPriceSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	classes : PropTypes.object,
	md : PropTypes.number,
	helpText : PropTypes.string,
	bulkQuotedPrices : PropTypes.array,

	dataDumpMap : PropTypes.object,
};

FMPBulkQuotedPriceSelect.defaultProps =  {
	md : 12,
	label : 'Quoted Price',
};

export default _.flow([
	withStyles(styles),
])(FMPBulkQuotedPriceSelect);